export enum CssRuleSelectorType {
    Class = "class",
    Tag = "tag",
    Id = "id",
}